import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpPickPackQueueWorklogContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/mrp-ppq-worklog-container.model';


@Injectable({
  providedIn: 'root'
})
export class MrpPickPackQueueWorklogService extends BaseApiTemplateService<MrpPickPackQueueWorklogContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + "pick-pack-queue-worklogs/" + Core2Config.BACKOFFICE_EP_SUFFIX

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX
      + Core2Config.MRP_PREFIX + "pick-pack-queue-worklogs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX
      + "pick-pack-queue-worklogs/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

}
